export function initSocialLogin() {
  if (typeof window.janrain !== 'object') window.janrain = {};
  if (typeof window.janrain.settings !== 'object') window.janrain.settings = {};

  window.janrain.settings.tokenUrl = $('meta[name="rpx_token_url"]').attr(
    'content'
  );
  window.janrain.settings.custom = true;

  function isReady() {
    window.janrain.ready = true;
  }
  if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', isReady, false);
  } else {
    window.attachEvent('onload', isReady);
  }

  var e = document.createElement('script');
  e.type = 'text/javascript';
  e.id = 'janrainAuthWidget';

  if (document.location.protocol === 'https:') {
    e.src = 'https://rpxnow.com/js/lib/login.icanmakeitbetter.com/engage.js';
  } else {
    e.src =
      'http://widget-cdn.rpxnow.com/js/lib/login.icanmakeitbetter.com/engage.js';
  }

  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(e, s);

  $('.janrainEngageEmbed').hide();
  $('.janrainShowEmbed').click(function() {
    $('.janrainEngageEmbed').toggle();
    return false;
  });
}
